/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminAtRiskWorkersListParams,
  AtRiskWorkerSummary,
  LocationRequestRead,
  PaginatedAtRiskWorkerListItemList
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getAdminAtRiskWorkersListUrl = (params?: AdminAtRiskWorkersListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/at-risk-workers/?${stringifiedParams}` : `/api/admin/at-risk-workers/`
}

/**
 * List of confirmed gig_applications inside the at-risk window for the admin dashboard.
 * @summary List at-risk workers (admin)
 */
export const adminAtRiskWorkersList = async (params?: AdminAtRiskWorkersListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedAtRiskWorkerListItemList> => {

  return customFetch<PaginatedAtRiskWorkerListItemList>(getAdminAtRiskWorkersListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminAtRiskWorkersListInfiniteQueryKey = (params?: AdminAtRiskWorkersListParams,) => {
    return [
    'infinite', `/api/admin/at-risk-workers/`, ...(params ? [params] : [])
    ] as const;
    }

export const getAdminAtRiskWorkersListQueryKey = (params?: AdminAtRiskWorkersListParams,) => {
    return [
    `/api/admin/at-risk-workers/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminAtRiskWorkersListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof adminAtRiskWorkersList>>, AdminAtRiskWorkersListParams['page']>, TError = void>(params?: AdminAtRiskWorkersListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminAtRiskWorkersList>>, TError, TData, QueryKey, AdminAtRiskWorkersListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminAtRiskWorkersListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminAtRiskWorkersList>>, QueryKey, AdminAtRiskWorkersListParams['page']> = ({ signal, pageParam }) => adminAtRiskWorkersList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminAtRiskWorkersList>>, TError, TData, QueryKey, AdminAtRiskWorkersListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminAtRiskWorkersListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof adminAtRiskWorkersList>>>
export type AdminAtRiskWorkersListInfiniteQueryError = void


export function useAdminAtRiskWorkersListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminAtRiskWorkersList>>, AdminAtRiskWorkersListParams['page']>, TError = void>(
 params: undefined |  AdminAtRiskWorkersListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminAtRiskWorkersList>>, TError, TData, QueryKey, AdminAtRiskWorkersListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAtRiskWorkersList>>,
          TError,
          Awaited<ReturnType<typeof adminAtRiskWorkersList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAtRiskWorkersListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminAtRiskWorkersList>>, AdminAtRiskWorkersListParams['page']>, TError = void>(
 params?: AdminAtRiskWorkersListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminAtRiskWorkersList>>, TError, TData, QueryKey, AdminAtRiskWorkersListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAtRiskWorkersList>>,
          TError,
          Awaited<ReturnType<typeof adminAtRiskWorkersList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAtRiskWorkersListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminAtRiskWorkersList>>, AdminAtRiskWorkersListParams['page']>, TError = void>(
 params?: AdminAtRiskWorkersListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminAtRiskWorkersList>>, TError, TData, QueryKey, AdminAtRiskWorkersListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List at-risk workers (admin)
 */

export function useAdminAtRiskWorkersListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminAtRiskWorkersList>>, AdminAtRiskWorkersListParams['page']>, TError = void>(
 params?: AdminAtRiskWorkersListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminAtRiskWorkersList>>, TError, TData, QueryKey, AdminAtRiskWorkersListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminAtRiskWorkersListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminAtRiskWorkersListQueryOptions = <TData = Awaited<ReturnType<typeof adminAtRiskWorkersList>>, TError = void>(params?: AdminAtRiskWorkersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAtRiskWorkersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminAtRiskWorkersListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminAtRiskWorkersList>>> = ({ signal }) => adminAtRiskWorkersList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminAtRiskWorkersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminAtRiskWorkersListQueryResult = NonNullable<Awaited<ReturnType<typeof adminAtRiskWorkersList>>>
export type AdminAtRiskWorkersListQueryError = void


export function useAdminAtRiskWorkersList<TData = Awaited<ReturnType<typeof adminAtRiskWorkersList>>, TError = void>(
 params: undefined |  AdminAtRiskWorkersListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAtRiskWorkersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAtRiskWorkersList>>,
          TError,
          Awaited<ReturnType<typeof adminAtRiskWorkersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAtRiskWorkersList<TData = Awaited<ReturnType<typeof adminAtRiskWorkersList>>, TError = void>(
 params?: AdminAtRiskWorkersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAtRiskWorkersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAtRiskWorkersList>>,
          TError,
          Awaited<ReturnType<typeof adminAtRiskWorkersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAtRiskWorkersList<TData = Awaited<ReturnType<typeof adminAtRiskWorkersList>>, TError = void>(
 params?: AdminAtRiskWorkersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAtRiskWorkersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List at-risk workers (admin)
 */

export function useAdminAtRiskWorkersList<TData = Awaited<ReturnType<typeof adminAtRiskWorkersList>>, TError = void>(
 params?: AdminAtRiskWorkersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAtRiskWorkersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminAtRiskWorkersListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminAtRiskWorkersSendReminderCreateUrl = (gigApplicationId: number,) => {




  return `/api/admin/at-risk-workers/${gigApplicationId}/send-reminder/`
}

/**
 * POST /api/admin/at-risk-workers/{id}/send-reminder/ — admin nudges an at-risk worker.
 *
 * Each call fires a fresh push notification. The first POST creates a
 * LocationRequest(request_type=ADMIN_REMINDER) row; subsequent POSTs UPDATE
 * `requested_at` on the same row (the UniqueConstraint keeps one row per
 * application) and re-queue the push. Always returns 201 with the reminder
 * row.
 */
export const adminAtRiskWorkersSendReminderCreate = async (gigApplicationId: number, options?: Parameters<typeof customFetch>[1]): Promise<LocationRequestRead> => {

  return customFetch<LocationRequestRead>(getAdminAtRiskWorkersSendReminderCreateUrl(gigApplicationId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdminAtRiskWorkersSendReminderCreateMutationKey = () => ['adminAtRiskWorkersSendReminderCreate'] as const;

export const getAdminAtRiskWorkersSendReminderCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAtRiskWorkersSendReminderCreate>>, TError,AdminAtRiskWorkersSendReminderCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminAtRiskWorkersSendReminderCreate>>, TError,AdminAtRiskWorkersSendReminderCreateMutationVariables, TContext> => {

const mutationKey = getAdminAtRiskWorkersSendReminderCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminAtRiskWorkersSendReminderCreate>>, AdminAtRiskWorkersSendReminderCreateMutationVariables> = (props) => {
          const {gigApplicationId} = props ?? {};

          return  adminAtRiskWorkersSendReminderCreate(gigApplicationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminAtRiskWorkersSendReminderCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminAtRiskWorkersSendReminderCreate>>>

    export type AdminAtRiskWorkersSendReminderCreateMutationError = void
    export type AdminAtRiskWorkersSendReminderCreateMutationVariables = {gigApplicationId: number}

    export const useAdminAtRiskWorkersSendReminderCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAtRiskWorkersSendReminderCreate>>, TError,AdminAtRiskWorkersSendReminderCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminAtRiskWorkersSendReminderCreate>>,
        TError,
        AdminAtRiskWorkersSendReminderCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminAtRiskWorkersSendReminderCreateMutationOptions(options), queryClient);
    }
    export const getAdminAtRiskWorkersSummaryRetrieveUrl = () => {




  return `/api/admin/at-risk-workers/summary/`
}

/**
 * Summary counters for the admin at-risk-workers dashboard.
 *
 * Returns warning / critical / on_time / total counts across confirmed
 * applications inside the configured time window. Admin-only.
 *
 * Honors `If-None-Match` for cheap heartbeat polling: when the counter
 * fields hash matches, returns 304 with the same ETag.
 * @summary Summary counters for at-risk workers
 */
export const adminAtRiskWorkersSummaryRetrieve = async ( options?: Parameters<typeof customFetch>[1]): Promise<AtRiskWorkerSummary> => {

  return customFetch<AtRiskWorkerSummary>(getAdminAtRiskWorkersSummaryRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminAtRiskWorkersSummaryRetrieveQueryKey = () => {
    return [
    `/api/admin/at-risk-workers/summary/`
    ] as const;
    }


export const getAdminAtRiskWorkersSummaryRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminAtRiskWorkersSummaryRetrieve>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAtRiskWorkersSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminAtRiskWorkersSummaryRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminAtRiskWorkersSummaryRetrieve>>> = ({ signal }) => adminAtRiskWorkersSummaryRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminAtRiskWorkersSummaryRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminAtRiskWorkersSummaryRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminAtRiskWorkersSummaryRetrieve>>>
export type AdminAtRiskWorkersSummaryRetrieveQueryError = void


export function useAdminAtRiskWorkersSummaryRetrieve<TData = Awaited<ReturnType<typeof adminAtRiskWorkersSummaryRetrieve>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAtRiskWorkersSummaryRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAtRiskWorkersSummaryRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminAtRiskWorkersSummaryRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAtRiskWorkersSummaryRetrieve<TData = Awaited<ReturnType<typeof adminAtRiskWorkersSummaryRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAtRiskWorkersSummaryRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAtRiskWorkersSummaryRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminAtRiskWorkersSummaryRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAtRiskWorkersSummaryRetrieve<TData = Awaited<ReturnType<typeof adminAtRiskWorkersSummaryRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAtRiskWorkersSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Summary counters for at-risk workers
 */

export function useAdminAtRiskWorkersSummaryRetrieve<TData = Awaited<ReturnType<typeof adminAtRiskWorkersSummaryRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAtRiskWorkersSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminAtRiskWorkersSummaryRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






